import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import {
  GROWTHBOOK_API_HOST,
  GROWTHBOOK_CLIENT_KEY,
  IS_GROWTBOOK_DEV_MODE_ENABLED,
  IS_GROWTHBOOK_AVAILABLE,
} from '../utils/growthbook';
import { useEffect } from "react";
import { AbilityLoader } from "./AbilityProvider";

const growthbook = new GrowthBook({
  apiHost: GROWTHBOOK_API_HOST,
  clientKey: GROWTHBOOK_CLIENT_KEY,
  enableDevMode: IS_GROWTBOOK_DEV_MODE_ENABLED,
  trackingCallback: (experiment, result) => {
    // TODO: Use your real analytics tracking system
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

export function FeatureFlagProvider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    if (IS_GROWTHBOOK_AVAILABLE) {
      growthbook.init({ streaming: true });
    }
  }, []);

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <AbilityLoader>
        {children}
      </AbilityLoader>
    </GrowthBookProvider>
  );
}
